let pendingPasswordResetToken: string | null = null;

export function capturePasswordResetTokenFromLocation(): void {
  if (window.location.pathname !== '/reset-password') {
    return;
  }

  const url = new URL(window.location.href);
  const fragmentParameters = new URLSearchParams(url.hash.slice(1));
  const token =
    fragmentParameters.get('token') ?? url.searchParams.get('token');

  if (!token) {
    return;
  }

  pendingPasswordResetToken = token;
  url.searchParams.delete('token');
  fragmentParameters.delete('token');
  url.hash = fragmentParameters.size > 0 ? fragmentParameters.toString() : '';

  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
}

export function consumePasswordResetToken(): string | null {
  const token = pendingPasswordResetToken;
  pendingPasswordResetToken = null;
  return token;
}
